<div class="pt-3">
    <!-- <div class="d-flex justify-content-between px-4">
        <div>
            @if(results.participationRate > 0){
                <span class="badge rounded-pill text-bg-light fw-normal">{{'poll_results.participation' | translate}}&nbsp;{{results.participationRate}}%</span>
            }
        </div>
        <div>
            @if(results.averageScore >0){
                <span class="badge rounded-pill text-bg-light fw-normal">{{'poll_results.average' | translate}}&nbsp;{{results.averageScore}}/5</span>
            }
        </div>
        <div class="">
            @if(results.trends){
            <i class="fa-solid fa-arrow-trend-up fa-2x"></i>
            }
        </div>
    </div> -->
    <div [attr.id]="'questionBarResult' + chartId"></div>
</div>
